export default {
  apiVersion: {
    admin: 'v1.21-admin',
    public: 'v1.21-public'
  },
  primaryColor: '#0d47a1',
  accentColor: '#fdd835',
  roles:{
    globalAdmin: 'global_admin'
  },
  featureFlags: {
    meal: 'Meal',
    gadgets: 'Gadgets',
    inviteTeam: 'InviteTeam',
    dashboardOccupancy: 'DashboardOccupancy',
    neoAccess: 'NeoAccess',
    neoAi: 'NeoAi',
  },
  mediaNPS: {
    app: 1,
    web: 2,
  }
}
